export default function registerUserRouteRefreshGuard (router) {
  router.beforeEach((to, from, next) => {
    // 既存ルートでは /users/:id が /users/register より先に定義されているため、
    // F5・直リンク時だけ register が動的IDとして解釈される。名前指定で静的ルートへ戻す。
    if (to.path === '/users/register' && to.name !== 'ユーザ登録') {
      next({ name: 'ユーザ登録', replace: true })
      return
    }
    next()
  })
}
